module.exports = __webpack_public_path__ + "static/media/detail11.170642ed.jpg";